import React from 'react';

import BottomSheet from 'components/DesignSystem/BottomSheet';

import './index.scss';

const TOPICS: { title: string; body: string }[] = [
  {
    title: 'Armazenamento de água no solo (ARM)',
    body: 'Percentual da capacidade máxima de água retida nas camadas superficiais do '
      + 'solo. Combina precipitação acumulada, evapotranspiração potencial e as '
      + 'propriedades físicas do solo de cada localidade.',
  },
  {
    title: 'Risco de estresse hídrico',
    body: 'Classifica cada localidade nos últimos 7 dias combinando dias sem chuva, ARM '
      + 'e déficit hídrico. As cores vão de baixo a muito alto e reaparecem como '
      + 'alerta sobre o pino da localidade no mapa.',
  },
  {
    title: 'Como ler o mapa',
    body: 'A mancha de cor mostra a variável selecionada interpolada entre as '
      + 'localidades monitoradas; a escala no topo do card indica os valores. Use '
      + 'as camadas para exibir localidades, alertas e limites estaduais.',
  },
];

export default function InfoSheet({
  open,
  dismiss,
}: {
  open: boolean;
  dismiss: () => void;
}) {
  return (
    <BottomSheet
      open={open}
      dismiss={dismiss}
      title="Como interpretar"
      className="agro-overview-mobile-info-sheet"
    >
      <div className="agro-overview-mobile-info-list">
        {TOPICS.map((topic) => (
          <div key={topic.title} className="agro-overview-mobile-info-topic">
            <h4 className="agro-overview-mobile-info-topic-title">{topic.title}</h4>
            <p className="agro-overview-mobile-info-topic-body">{topic.body}</p>
          </div>
        ))}
      </div>
    </BottomSheet>
  );
}
